import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    loadingPage: false,
    userId: 0,
    appLoaded: false
  },
  mutations: {

    changeLoader(state, value){

      // console.log(`before, state.loadingPage: ${state.loadingPage}`)

      state.loadingPage =  value;

      // console.log(`after, state.loadingPage: ${state.loadingPage}`)
    },

    updateUserId(state, value){

      state.userId = value;
      
      state.appLoaded = true;
      // console.log(`state.userId: ${state.userId}`);
    },

    appIsLoaded(state, value){

      state.appLoaded = value;
      // console.log(`state.appLoaded: ${state.appLoaded}`);

    }
  },
  actions: {

    setUserId() {
      // await fetch(API_FUNCTION_UPDATE_FILES)
      // return store.dispatch('getFiles')
  }

  },
  modules: {
  }
})
